import { useMediaQuery } from 'react-responsive';
import { mobileBreakpoint, tabletBreakpoint } from '../ui/index';

export function useIsDesktop() {
  return useMediaQuery({
    query: `(min-width: ${tabletBreakpoint})`,
  });
}

export function useIsMobile() {
  return useMediaQuery({
    query: `(max-width: ${mobileBreakpoint})`,
  });
}

export function useIsMobileOrTablet() {
  return useMediaQuery({
    query: `(max-width: ${tabletBreakpoint})`,
  });
}
